<template>
  <v-card-text>
    <v-row>

      <v-col cols="6">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Legal Entity Name</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.legalName }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="6">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Alt Corporate Name</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.legalNameAlt }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="12">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Description of Business Operations</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.descriptionOfOperations }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <!-- eslint-disable-next-line max-len -->
            <v-list-item-title style="white-space: unset;">Owner/Member/Partner(s) Name(s) and Percentage(s)</v-list-item-title>
            <!-- eslint-disable-next-line max-len -->
            <v-list-item-subtitle style="white-space: unset;">{{ prospectPacket.companyInfo.ownerNames }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Years in Business</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.yearsInBusiness }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Years at location</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.yearsAtLocation }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>FEIN/Tax ID</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.fedId }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Corporation Type</v-list-item-title>
            <v-list-item-subtitle>{{ prospectPacket.companyInfo.corporationType }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Primary Contact</v-list-item-title>
            <v-list-item-subtitle>{{ contact.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Address Line 1</v-list-item-title>
            <v-list-item-subtitle>{{ contact.address1 }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Address Line 2</v-list-item-title>
            <v-list-item-subtitle>{{ contact.address2 }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>City</v-list-item-title>
            <v-list-item-subtitle>{{ contact.city }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>State</v-list-item-title>
            <v-list-item-subtitle>{{ contact.state }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Postal Code</v-list-item-title>
            <v-list-item-subtitle>{{ contact.zip }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Telephone Number</v-list-item-title>
            <v-list-item-subtitle>{{ contact.phone }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col cols="4">
        <v-list-item>
          <v-list-item-content class="font-weight-medium">
            <v-list-item-title>Fax Number</v-list-item-title>
            <v-list-item-subtitle>{{ contact.fax }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'GeneralCompanyInformation',
  data: () => ({
    temp: null,
  }),
  computed: {
    prospectPacket() {
      return this.$store.state.prospectPacket;
    },
    contactType() {
      return this.$store.state.prospectPacket.companyInfo.primaryContactType;
    },
    contact() {
      return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.contactType);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item__title, .v-list-item__subtitle {
  white-space: unset !important;
}
</style>
